// Fragment "custom domains" — the operator's Custom domains screen
// (super_admin/CustomDomainsManager.jsx, backend/modules/custom_domains routes under
// /api/super-admin/custom-domains). Merged by ./index.js.
export default {
  fr: {
    "nav.customDomains": "Domaines personnalisés",
    "cdm.title": "Domaines personnalisés",
    "cdm.subtitle": "Les domaines connectés par les cabinets, leur état et le délai avant qu'un domaine déconnecté soit retiré.",
    "cdm.reload": "Actualiser",
    "cdm.empty": "Aucun cabinet n'a connecté de domaine.",
    "cdm.h.domain": "Domaine",
    "cdm.h.practice": "Cabinet",
    "cdm.h.status": "État",
    "cdm.h.checked": "Dernière vérification",
    "cdm.h.detail": "Détail",
    "cdm.h.actions": "Actions",
    "cdm.kind.apex": "racine",
    "cdm.kind.subdomain": "sous-domaine",
    "cdm.status.pending_dns": "En attente du DNS",
    "cdm.status.provisioning": "Sécurisation",
    "cdm.status.live": "En ligne",
    "cdm.status.failed": "Échec",
    "cdm.status.lapsed": "Déconnecté",
    "cdm.recheck": "Revérifier",
    "cdm.remove": "Retirer",
    "cdm.removeConfirm": "Retirer {domain} de {practice} ? Le site cessera de répondre sur ce domaine.",
    "cdm.rechecked": "{domain} : {status}",
    "cdm.removed": "{domain} retiré.",
    "cdm.edgeError": "L'hébergement (CloudFront) n'a pas pu être joint : {message}",
    "cdm.teardowns": "{n} retrait(s) en cours côté CloudFront",
    "cdm.policy.title": "Délais avant retrait",
    "cdm.policy.body": "Quand un domaine en ligne cesse de pointer vers Solunary, ses liens reviennent sur l'adresse Solunary et le cabinet est prévenu ; s'il n'est pas rétabli dans le premier délai, il est retiré. Un domaine jamais connecté (DNS en attente ou échec) est libéré après le second délai, pour qu'il ne reste pas bloqué si quelqu'un d'autre en est le vrai propriétaire.",
    "cdm.policy.lapse": "Domaine déconnecté (jours)",
    "cdm.policy.unproven": "Domaine jamais connecté (jours)",
    "cdm.policy.save": "Enregistrer",
    "cdm.policy.saved": "Délais enregistrés.",
    "cdm.policy.invalid": "Saisis un nombre entier de jours entre {min} et {max}.",
    "cdm.policy.updated": "Modifié le {date} par {who}",
    "cdm.error": "Erreur",
  },
  en: {
    "nav.customDomains": "Custom domains",
    "cdm.title": "Custom domains",
    "cdm.subtitle": "The domains practices have connected, their state, and how long a disconnected domain is held before it is removed.",
    "cdm.reload": "Reload",
    "cdm.empty": "No practice has connected a domain.",
    "cdm.h.domain": "Domain",
    "cdm.h.practice": "Practice",
    "cdm.h.status": "Status",
    "cdm.h.checked": "Last check",
    "cdm.h.detail": "Detail",
    "cdm.h.actions": "Actions",
    "cdm.kind.apex": "root",
    "cdm.kind.subdomain": "subdomain",
    "cdm.status.pending_dns": "Waiting for DNS",
    "cdm.status.provisioning": "Securing",
    "cdm.status.live": "Live",
    "cdm.status.failed": "Failed",
    "cdm.status.lapsed": "Disconnected",
    "cdm.recheck": "Re-check",
    "cdm.remove": "Remove",
    "cdm.removeConfirm": "Remove {domain} from {practice}? The site will stop answering on this domain.",
    "cdm.rechecked": "{domain}: {status}",
    "cdm.removed": "{domain} removed.",
    "cdm.edgeError": "Hosting (CloudFront) couldn't be reached: {message}",
    "cdm.teardowns": "{n} removal(s) in progress on CloudFront",
    "cdm.policy.title": "Periods before removal",
    "cdm.policy.body": "When a live domain stops pointing to Solunary, its links move back to the Solunary address and the practice is told; if it isn't restored within the first period, it is removed. A domain that never went live (waiting for DNS, or failed) is released after the second period, so it can't stay blocked when someone else really owns it.",
    "cdm.policy.lapse": "Disconnected domain (days)",
    "cdm.policy.unproven": "Never-connected domain (days)",
    "cdm.policy.save": "Save",
    "cdm.policy.saved": "Periods saved.",
    "cdm.policy.invalid": "Enter a whole number of days between {min} and {max}.",
    "cdm.policy.updated": "Changed on {date} by {who}",
    "cdm.error": "Error",
  },
  es: {
    "nav.customDomains": "Dominios personalizados",
    "cdm.title": "Dominios personalizados",
    "cdm.subtitle": "Los dominios que conectaron las consultas, su estado y cuánto tiempo se conserva un dominio desconectado antes de quitarlo.",
    "cdm.reload": "Actualizar",
    "cdm.empty": "Ninguna consulta ha conectado un dominio.",
    "cdm.h.domain": "Dominio",
    "cdm.h.practice": "Consulta",
    "cdm.h.status": "Estado",
    "cdm.h.checked": "Última comprobación",
    "cdm.h.detail": "Detalle",
    "cdm.h.actions": "Acciones",
    "cdm.kind.apex": "raíz",
    "cdm.kind.subdomain": "subdominio",
    "cdm.status.pending_dns": "Esperando el DNS",
    "cdm.status.provisioning": "Protegiendo",
    "cdm.status.live": "En línea",
    "cdm.status.failed": "Error",
    "cdm.status.lapsed": "Desconectado",
    "cdm.recheck": "Volver a comprobar",
    "cdm.remove": "Quitar",
    "cdm.removeConfirm": "¿Quitar {domain} de {practice}? El sitio dejará de responder en este dominio.",
    "cdm.rechecked": "{domain}: {status}",
    "cdm.removed": "{domain} quitado.",
    "cdm.edgeError": "No se pudo contactar con el alojamiento (CloudFront): {message}",
    "cdm.teardowns": "{n} eliminación(es) en curso en CloudFront",
    "cdm.policy.title": "Plazos antes de quitarlo",
    "cdm.policy.body": "Cuando un dominio en línea deja de apuntar a Solunary, sus enlaces vuelven a la dirección de Solunary y se avisa a la consulta; si no se restablece en el primer plazo, se quita. Un dominio que nunca llegó a conectarse (DNS pendiente o error) se libera tras el segundo plazo, para que no quede bloqueado si otra persona es su verdadera propietaria.",
    "cdm.policy.lapse": "Dominio desconectado (días)",
    "cdm.policy.unproven": "Dominio nunca conectado (días)",
    "cdm.policy.save": "Guardar",
    "cdm.policy.saved": "Plazos guardados.",
    "cdm.policy.invalid": "Escribe un número entero de días entre {min} y {max}.",
    "cdm.policy.updated": "Modificado el {date} por {who}",
    "cdm.error": "Error",
  },
};
